import { useState } from "react"

export default function HomeTest() {
  const [playKey, setPlayKey] = useState(0)
  const isHover = playKey > 0

  // Stagger. The 2s base delay on first load lets the scene settle
  // before the text wipes in; 1.2s now rather than 2s, because with a
  // third line the last one wasn't arriving until ~2.3s and read as
  // missing rather than delayed.
  const d = (n) => ({ "--d": isHover ? `${n * 0.06}s` : `${1.2 + n * 0.15}s` })
  const cls = `wipe-line${isHover ? " wipe-fast" : ""}`

  return (
    <div className="home-overlay">
      {/* Stripped back to two lines. The eyebrow label, the three-line
          tagline, the role/experience meta row and the app link all used
          to sit here — between them they said the same thing four times
          over. Second line uses <em> for the dimmed treatment, which
          .home-tagline em already provides. */}
      <div className="home-identity" style={{ pointerEvents: "all" }}>
        <h1 className="home-tagline" onMouseEnter={() => setPlayKey(k => k + 1)}>
          <span key={`1-${playKey}`} className={cls} style={d(0)}>Rice Tseng</span><br />
          <span key={`2-${playKey}`} className={cls} style={d(1)}><em>Design Director at OKX</em></span>
        </h1>
        <div className="home-sub">
          <span key={`3-${playKey}`} className={cls} style={d(2)}>
            Ex-Principal Product Designer @ Grab
          </span>
        </div>
      </div>
    </div>
  )
}
